import { Text } from 'react-gldn-kit';

import styles from './ProgressWagering.module.css';

type Props = {
  fullRolled: number;
  rolled: number;
  percent: number;
  wager: number;
  classes?: string;
};

const ProgressWagering = (props: Props) => {
  const { fullRolled, percent, classes, rolled } = props;

  return (
    <div className={classes}>
      <div className={styles.titleRow}>
        <div className={styles.rolledRow}>
          <div className={styles.progressText}>
            <Text idT="vipClub.progress" />
          </div>
          <div className={styles.rolledWrapper}>
            <div className={styles.rolled}>{rolled}</div>/{fullRolled}
          </div>
        </div>

        <div className={styles.maxValue}>{percent.toFixed(2)}%</div>
      </div>
      <div className={styles.wrapperProgressWagering}>
        <div className={styles.progress} style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
};

export default ProgressWagering;
